import React, { useCallback, useState } from 'react';
import Tooltip from '../../components/common/Tooltip';
import { buildQueroComecarUrl } from '../../utils/studentPublicLinks';
import styles from './QueroComecarCopyLinkButton.module.css';

const COPY_LABEL = 'Copiar link Quero Começar';

const QueroComecarCopyLinkButton: React.FC = () => {
  const [isCopying, setIsCopying] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    if (isCopying) {
      return;
    }

    setIsCopying(true);

    try {
      await navigator.clipboard.writeText(buildQueroComecarUrl());
      setIsCopied(true);
      window.setTimeout(() => {
        setIsCopied(false);
      }, 2500);
    } catch (copyError) {
      alert(copyError instanceof Error ? copyError.message : 'Não foi possível copiar o link.');
    } finally {
      setIsCopying(false);
    }
  }, [isCopying]);

  const iconName = isCopying ? 'progress_activity' : isCopied ? 'done' : 'content_copy';
  const label = isCopying ? 'Copiando...' : isCopied ? 'Copiado' : 'Quero Começar';

  return (
    <Tooltip content={COPY_LABEL}>
      <button
        className={styles.button}
        onClick={() => {
          void handleCopy();
        }}
        aria-label={COPY_LABEL}
        type="button"
        disabled={isCopying}
      >
        <span
          className={`material-symbols-outlined ${isCopying ? styles.spinner : ''}`.trim()}
          aria-hidden="true"
        >
          {iconName}
        </span>
        <span className={styles.label}>{label}</span>
      </button>
    </Tooltip>
  );
};

export default QueroComecarCopyLinkButton;
